/**
 * @group Constants
 * @summary
 * <blockquote>Constants for learning content type values</blockquote>
 * 
 * @example
 * ```typescript
 * import { LEARNING_CONTENT_TYPES } from '@shared/constants';
 * 
 * if (content.type === LEARNING_CONTENT_TYPES.RICH_TEXT) {
 *   // Handle rich text content
 * }
 * ```
 */
export const LEARNING_CONTENT_TYPES = {
  RICH_TEXT: 'rich_text',
  CODE_EDITOR: 'code_editor',
  IMAGE_GALLERY: 'image_gallery',
  VIDEO_PLAYER: 'video_player',
  INTERACTIVE_DEMO: 'interactive_demo',
  QUIZ_EMBED: 'quiz_embed',
  FILE_DOWNLOAD: 'file_download',
  STEP_BY_STEP: 'step_by_step',
  CHECKLIST: 'checklist',
  EXTERNAL_LINK: 'external_link'
} as const; 